//Layouts
import DashboardLayout from 'src/pages/Layout/DashboardLayout.vue';
import AuthLayout from 'src/pages/Pages/AuthLayout.vue';
// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue';
// Pages
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ 'src/pages/Dashboard/Dashboard.vue');
const Login = () => import(/* webpackChunkName: "pages" */ 'src/pages/Pages/Login.vue');

var routes = [{
    path: '/',
    component: AuthLayout,
    name: 'Authentication',
    children: [
      {
        path: '/',
        name: 'Login',
        component: Login
      },
    ]
  }];

if(window.user){
  routes = [{
    path: '/',
    component: DashboardLayout,
    children: [{
        path: '/',
        name: 'Dashboard',
        component: Dashboard
      }]
  }];
}

export default routes;
